import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>Dr. MANSUKH MANDAVIYA</h2>
                        <div class="mini_img-innr">
                          <img
                            src="../images/minister/manshukh.jpg"
                            class="img-responsive"
                          />
                        </div>
                        <p style={{ marginTop: "15px" }}>
                          Dr. Mansukh Mandaviya is the Minister of Health and
                          Family Welfare; and Minister of Chemicals and
                          Fertilizers in Government of India. Mandaviya was born
                          in a small village named Hanol in Palitana district of
                          Gujarat state in a middle-class farmer’s family. He
                          holds a Postgraduate degree in Political Science from
                          Bhavnagar University. Mandaviya was very active in
                          politics and serving people since his youth. He became
                          a member of ABVP and soon he grabbed his position as a
                          state executive committee member of ABVP, Gujarat
                          unit. Seeing his intellect, skills and the zeal to
                          work hard he was appointed as a leader of YuvaMorcha
                          and then the president of Palitana BJP unit. He also
                          holds a record of being the youngest MLA in Gujarat.
                        </p>
                        <p>
                          Working hard to serve the people and uplifting them
                          was his only goal and thus he organized two Padyatras
                          of 123 Km and 127 Km for the cause of Girl Education,
                          BetiBachao, BetiPadhao and VayasanHatao. At a young
                          age of 38, he was elected as a member of Rajya Sabha.
                          He was also a part of various standing committees in
                          various fields.
                        </p>
                        <p>
                          With his hard work and intelligence, he was appointed
                          as Secretary for state unit BJP in 2013 and General
                          Secretary in 2014. Later in 2014, he was appointed as
                          Gujarat State Incharge of BJP’s High-tech & Mega
                          Membership Drive Campaign which led to 1 crore people
                          joining BJP in Gujarat.
                        </p>
                        <p>
                          Mandaviya is well known for his intellectual analysis
                          and thought leadership, which he also exhibited in his
                          speech on “2030 Agenda for Sustainable Development” at
                          the United Nations. He has travelled to lot many
                          countries to explore their policies & management to
                          help India grow at the fastest pace.
                        </p>
                        <p>
                          On 5th July 2016, he sworn in as a Minister of State
                          for Road Transport & Highways, Shipping and Chemical &
                          Fertilizers in Government of India. Serving as a
                          minister, he has implemented a lot of plans and
                          thoughts to get the work done quickly and efficiently.
                        </p>
                        <p>
                          He was re-selected for the Second Term for Member of
                          Parliament, Rajya Sabha during March, 2018. With his
                          decisive and bold leadership, he has helped increasing
                          the per day road construction speed, decreasing the
                          cost of Urea and other fertilizers, establishing more
                          than 4000 Jan Aushadhi stores to provide more than 800
                          medicines at affordable rates and reducing the cost of
                          heart stent and knee implants. Above this, he has not
                          left any stone unturned to help the common man,
                          farmers and businesses.
                        </p>
                        <p>
                          Mandaviya has been a part of various delegations,
                          twice with the President and once with vice president
                          to sign MOUs and develop bilateral relations with
                          other Nations. In the Asian Continent he has visited
                          China, Israel, Oman, Nepal, Dubai and Uzbekistan. He
                          also visited European countries like England &
                          Germany, South American countries like Brazil &
                          Argentina. He has visited lot many countries of Africa
                          like Kenya, Uganda, Tanzania, Rwanda, Algeria,
                          Hungary, Equatorial Guinea, Swaziland and Zambia. In
                          an Oceania Region Shri Mandaviya visited New Zealand,
                          Tonga, Fiji and Australia.
                        </p>
                        <p>
                          He has played a vital role in the growth and
                          development of New India with his hard work,
                          organizational skills and intellect. Again in 2019, he
                          sworn in as a Minister of State (Independent Charge)
                          for Ministry of Shipping and Minister of State for
                          Chemical & Fertilizers in Government of India. With
                          effect from 07.07.2021, he was elevated to the
                          Minister for Chemicals and Petrochemicals and the
                          Minister for Health and Family Welfare in the
                          Government of India
                        </p>

                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
